import React, { useContext, useState, useEffect } from 'react'
import { MenuItem, MenuList, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux';
import CopyAndPaste from '../../RightContextMenu/ContextActions/CopyAndPaste';
import { ParentScreenCtx } from '../../../pages/workbench_build/WorkbenchBuild';
import Delete from '../../RightContextMenu/ContextActions/Delete';

function NodeToolbarOptionsMenu({ nodeData, isCopied, setIsCopied }) {
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const { t } = useTranslation();
  const [menuOption, setMenuOption] = useState('')
  const [isDisable, setIsDisable] = useState(false);
  const { tree, currentTab } = useSelector((state) => state.treeData[parentScreen].rightTree);
  const selectedKeysArray = tree[currentTab].selectedKeysArray;

  const checkDisable = () => {
    return selectedKeysArray.includes("wf-0")
  }

  useEffect(() => {
    setIsDisable(checkDisable());
  }, [selectedKeysArray])

  const handleClick = (opt) => {
    setMenuOption(opt)
  }

  const handleDelete = () => {
    handleClick(t('MNU_DEL_WF_ITEM'))
  }

  const handleCopy = () => {
    setIsCopied({ paste: false, copy: true, dispatchFrom: 'NodeToolbar', treeType: parentScreen })
    setMenuOption('')
  }

  const handlePaste = () => {
    setIsCopied({ ...isCopied, paste: true, dispatchFrom: 'NodeToolbar', treeType: parentScreen })
    setMenuOption('')
  }

  return (
    <>
      <Paper elevation={3} sx={{ width: "12rem" }}>
        <MenuList sx={{ paddingTop: 0, paddingBottom: 0 }}>
          <MenuItem name={t("MNU_DEL_WF_ITEM")} onClick={handleDelete}>
            <span className='SYMBOL_DELETE'></span>
            <span className='margin-left-8'>{t("MNU_DEL_WF_ITEM")}</span>
          </MenuItem>
          <MenuItem disabled={isDisable || selectedNode?.ICON_DISPLAY === 'CONDITION_ELSE'} name={t("MNU_COPY")} onClick={handleCopy}>
            <span className={"COPY"}></span>
            <span className={"margin-left-8"}>{t("MNU_COPY")}</span>
          </MenuItem>
          {isCopied?.copiedNodes?.length ? (
            <MenuItem name={t("MNU_PASTE")} onClick={handlePaste}>
              <span className={"DOCUMENT"}></span>
              <span className={"margin-left-8"}>{t("MNU_PASTE")}</span>
            </MenuItem>
          ) : null}
        </MenuList>
      </Paper>
      <CopyAndPaste 
        isCopied={isCopied} 
        setIsCopied={setIsCopied} 
        contextMenuType="NodeToolbar" 
        treeType={parentScreen}
      />
      <Delete openModal={menuOption === t('MNU_DEL_WF_ITEM')} toggle={() => handleClick(null)}/>
    </>
  )
}

export default NodeToolbarOptionsMenu

